var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "4 4 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.707 12 5.146-5.146a.5.5 0 0 0-.707-.707L12 11.293 6.854 6.146a.5.5 0 0 0-.707.707L11.293 12l-5.146 5.146a.5.5 0 0 0 .707.708L12 12.707l5.146 5.146a.5.5 0 1 0 .708-.706L12.707 12z"
})));

export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "2e4ff163292c124fefed8f1e3fe08cd7.svg";